export enum Color {
  Red = 'red',
  Green = 'green',
  Blue = 'blue',
  Purple = 'purple',
  Yellow = 'yellow',
  Orange = 'orange',
  Cyan = 'cyan',
  Indigo = 'indigo',
  White = 'white',
  AlwaysWhite = 'always-white',
  Pink = 'pink',
  LightPink = 'lightPink',
  DeepPink = 'deepPink',
  DeepYellow = 'deepYellow',
  DeepOrange = 'deepOrange',
  LightGreen = 'lightGreen',
  DeepBlue = 'deepBlue',
  RoyalBlue = 'royalBlue',
  LightBlue = 'lightBlue',
  Asphalt = 'asphalt',
  Night = 'night',
  Slate = 'slate',
  Steel = 'steel',
  LightSteel = 'light-steel',
  Dust = 'dust',
  Fog = 'fog',
  Sky = 'sky',
  Ice = 'ice',
  Smoke = 'smoke',
  Teal = 'teal',
  Main = 'main'
}

export enum TextColor {
  Heading = 'heading',
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Main = 'main',
  Red = 'red',
  Yellow = 'yellow',
  Green = 'green',
  Blue = 'blue',
  Purple = 'purple',
  Orange = 'orange',
  Cyan = 'cyan',
  Indigo = 'indigo',
  Teal = 'teal'
}

export enum DeprecatedColor {
  Coral = 'coral',
  Arctic = 'arctic',
  Azure = 'azure',
  Violet = 'violet',
  Pink = 'pink'
}

export type IconButtonColor = Color.Blue | Color.Yellow | Color.Red | Color.Green | Color.Purple | Color.Main
export type MainColor = Color.Red | Color.Green | Color.Blue | Color.Purple | Color.Yellow | Color.Ice | Color.Main
export type SecondaryColor = Color.Orange | Color.Cyan | Color.Indigo
export type GreyColor =
  | Color.White
  | Color.Asphalt
  | Color.Night
  | Color.Slate
  | Color.Steel
  | Color.LightSteel
  | Color.Dust
  | Color.Fog
  | Color.Sky
  | Color.Ice
  | Color.Smoke

export type OverlayColor = Color.White | Color.Ice

export type BadgeColor =
  | Color.Steel
  | Color.Purple
  | Color.Red
  | Color.Blue
  | Color.Yellow
  | Color.Green
  | Color.Orange
  | Color.Cyan
  | Color.Indigo
  | Color.Main

export type IconColor =
  | Color.Blue
  | Color.Yellow
  | Color.Red
  | Color.Green
  | Color.Purple
  | Color.Orange
  | Color.Cyan
  | Color.Indigo
  | Color.Teal
